module.exports = __webpack_public_path__ + "img/logo.38a13d9d.png";